module.exports = __webpack_public_path__ + "static/media/buttons-icon-buttons-18-down-arrow.1da470a9.svg";